import { Action, Reducer } from 'redux';
import {
    UserHierarchyActionTypes,
    UserHierarchyState,
    UserHierarchyTypes
} from './userHierarchyTypes';

export const INITIAL_STATE: UserHierarchyState = {
  userHierarchy: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const userHierarchyReducer: Reducer<UserHierarchyState> = (
  state: UserHierarchyState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as UserHierarchyActionTypes;

  switch (actionTypes.type) {
    case UserHierarchyTypes.GET_USER_HIERARCHY:
      return {
        ...state,
        userHierarchy: {
          ...state.userHierarchy,
          isLoading: true
        }
      };

    case UserHierarchyTypes.SAVE_USER_HIERARCHY:
      return {
        ...state,
        userHierarchy: {
          ...state.userHierarchy,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };

    case UserHierarchyTypes.RESET_REDUCER_USER_HIERARCHY:
      return {
        ...state,
        userHierarchy: INITIAL_STATE.userHierarchy
      };

    default:
      return state;
  }
};

export default userHierarchyReducer;
